var React = require('react');

function RightArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"clipRule":"evenodd","d":"m10.5625 6.48463c.0004-.35841-.1532-.69964-.4216-.9365l-6.02832-5.314059c-.41546-.349321-1.03326-.3024144-1.39145.105647-.35819.408062-.32576 1.028022.07304 1.396332l5.2715 4.64675c.02927.02571.04606.06282.04606.10183 0 .039-.01679.07611-.04606.10183l-5.2715 4.64674c-.27749.2333-.4071.5989-.33867.9554.06843.3564.32416.6477.66823.7612s.7225.0314.98885-.2146l6.02612-5.31245c.2691-.23726.4235-.57896.4238-.93812z","fill":"#c69724","fillRule":"evenodd","opacity":".500837"}));
}

RightArrowInline.defaultProps = {"fill":"none","height":"13","viewBox":"0 0 13 13","width":"13"};

module.exports = RightArrowInline;

RightArrowInline.default = RightArrowInline;
